import React, { useEffect, useRef } from "react";
import { View, Text, Animated } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import { FontFamilies } from "@/constants/Typography";
import Images from "@/assets/images";
import { Image } from "expo-image";

const OnboardSlide13 = ({ next }: { next: () => void }) => {
  const spin = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    Animated.loop(
      Animated.timing(spin, {
        toValue: 1,
        duration: 1200,
        useNativeDriver: true,
      })
    ).start();
    setTimeout(() => {
      next();
    }, 3000);
  }, []);

  const rotate = spin.interpolate({
    inputRange: [0, 1],
    outputRange: ["0deg", "360deg"],
  });

  return (
    <View style={styles.container}>
      <View />
      <View>
        <Image
          source={Images.coin3d}
          style={styles.coin}
          contentFit="contain"
        />
        <Text style={styles.caption}>
          Estimating money{"\n"}you haven&apos;t claimed
        </Text>
      </View>
      <Animated.View style={[styles.spinner, { transform: [{ rotate }] }]} />
    </View>
  );
};

export default OnboardSlide13;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
  },
  coin: {
    width: 150,
    height: 150,
    marginTop: 40,
    alignSelf: "center",
  },
  caption: {
    fontFamily: FontFamilies.InterTight.Bold,
    fontSize: 24,
    lineHeight: 32,
    color: "#EBFFEE",
    textAlign: "center",
    opacity: 0.7,
  },
  spinner: {
    width: 32,
    height: 32,
    borderRadius: 16,
    borderWidth: 4,
    borderColor: "#EBFFEE",
    borderTopColor: "transparent",
    marginTop: 48,
  },
});
